import type { ReactNode } from 'react';

/**
 * A half-height panel docked at the bottom of the mobile editor. It sits in
 * the page flow rather than over a scrim, so the canvas above stays visible,
 * live and tappable while it is open (and re-fits to the space left).
 */
export function EditorSheet({
  title,
  onClose,
  onBack,
  children,
}: {
  title: ReactNode;
  onClose: () => void;
  /** Shows a ‹ button for a drilled-in view (e.g. one widget of a playlist). */
  onBack?: () => void;
  children: ReactNode;
}): ReactNode {
  return (
    <section className="editor-sheet" aria-label={typeof title === 'string' ? title : undefined}>
      <button type="button" className="editor-sheet-grabber" aria-label="Close panel" onClick={onClose} />
      <div className="editor-sheet-head">
        {onBack ? (
          <button type="button" className="icon-btn" aria-label="Back" onClick={onBack}>
            ‹
          </button>
        ) : null}
        <strong className="ellipsis">{title}</strong>
        <button type="button" className="icon-btn" aria-label="Close panel" onClick={onClose}>
          ✕
        </button>
      </div>
      <div className="editor-sheet-body">{children}</div>
    </section>
  );
}
